import { render, staticRenderFns } from "./ScheduleSpan.vue?vue&type=template&id=22f1e546&scoped=true"
import script from "./ScheduleSpan.vue?vue&type=script&lang=js"
export * from "./ScheduleSpan.vue?vue&type=script&lang=js"
import style0 from "./ScheduleSpan.vue?vue&type=style&index=0&id=22f1e546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1e546",
  null
  
)

export default component.exports